import { isDicePlusReady, requestExternalRoll } from '../obr/dicePlus.ts';
import type { DicePlusRequester } from './diceRolls.ts';

/** Result channel prefix for the player sheet, separate from the GM bridge's. */
export const SHEET_DICE_SOURCE = 'com.lordofdisndat.dcc.sheet';

/** Dice+ when it answers in this room, otherwise null (the sheet rolls). */
export async function dicePlusRequester(): Promise<DicePlusRequester> {
  if (!(await isDicePlusReady())) return null;
  return (notation) => requestExternalRoll({ notation, target: 'everyone', showResults: true, source: SHEET_DICE_SOURCE });
}
